import { SxProps, Theme } from "@mui/material";
import { colorPalette } from "../../colors/colors";

export const backdropStyles: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "100vh",
  padding: 3,
  textAlign: "center",
  backgroundColor: "rgba(0, 0, 0, 0.7)",
  backdropFilter: "blur(8px)",
  width: "100%",
  position: "fixed",
  top: 0,
  left: 0,
};

export const modalContentStyles: SxProps<Theme> = {
  backgroundColor: "#FFE5E5",
  borderRadius: "16px",
  padding: "32px",
  maxWidth: 500,
  width: "100%",
  boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
  border: "1px solid rgba(255, 255, 255, 0.1)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "20px",
};

export const iconContainerStyles: SxProps<Theme> = {
  width: "64px",
  height: "64px",
  borderRadius: "50%",
  backgroundColor: "#DC2626",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 4px 12px rgba(220, 38, 38, 0.4)",
};

export const messageContainerStyles: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  flexWrap: "wrap",
  justifyContent: "center",
};

export const messageTextStyles: SxProps<Theme> = {
  color: "#991B1B",
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: 1.5,
};

export const reloadButtonStyles: SxProps<Theme> = {
  backgroundColor: colorPalette.blue300,
  color: "#FFFFFF",
  padding: "12px 32px",
  borderRadius: "8px",
  fontSize: "14px",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
  "&:hover": {
    backgroundColor: "#1565c0",
    boxShadow: "0 6px 16px rgba(25, 118, 210, 0.4)",
    transform: "translateY(-1px)",
  },
  transition: "all 0.2s ease-in-out",
  mt: 1,
};
